export class ConflictResolvingError extends Error {}
